import api from "./api";

// Fetch all Agents
export const fetchAllAgents = async (
    page = 1,
    size = 20,
    filterField = "status",
    filterValue = ""
) => {
    try {
        const params = {
            page,
            size,
            filter_field: filterField,
        };

        if (filterValue) {
            params.filter_value = filterValue;
        }

        const response = await api.get(
            "/agent-management/agents",
            {
                params,
            }
        );

        if (response.status === 200) {
            return response.data;
        }

        return {
            error: "Unexpected response from server",
        };

    } catch (error) {
        console.error(
            "Error fetching agents:",
            error.message || error
        );

        return {
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch agents",
        };
    }
};


// Update Agent status
export const updateAgentStatus = async (
    agentId,
    status,
    statusReason = null
) => {
    try {
        const payload = {
            status,
            ...(statusReason && {
                status_reason: statusReason,
            }),
        };

        const response = await api.put(
            `/agent-management/agents/${agentId}/status`,
            payload
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {
            const agentData =
                response.data.data;

            return {
                success: true,
                data: {
                    ...agentData,
                    id:
                        agentData?.agent_id ||
                        agentId,
                },
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                response.data?.detail ||
                "Unexpected response from server",
        };

    } catch (error) {
        console.error(
            "Error updating agent status:",
            error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to update agent status",
        };
    }
};